import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';
const SkeletonFooter: React.FC = () => {
  return <footer className="bg-gray-100 pt-10 pb-6 mt-10" data-sentry-component="SkeletonFooter" data-sentry-source-file="footer-loader.tsx">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap justify-between text-center md:text-left">
          <div className="w-full md:w-1/4 mb-8">
            <Skeleton className="h-12 w-2/3 mx-auto md:mx-0 mb-6" data-sentry-element="Skeleton" data-sentry-source-file="footer-loader.tsx" />
            <div className="flex justify-center md:justify-start space-x-2 mt-8">
              <Skeleton className="h-6 w-6 rounded" data-sentry-element="Skeleton" data-sentry-source-file="footer-loader.tsx" />
              <Skeleton className="h-6 w-6 rounded" data-sentry-element="Skeleton" data-sentry-source-file="footer-loader.tsx" />
              <Skeleton className="h-6 w-6 rounded" data-sentry-element="Skeleton" data-sentry-source-file="footer-loader.tsx" />
              <Skeleton className="h-6 w-6 rounded" data-sentry-element="Skeleton" data-sentry-source-file="footer-loader.tsx" />
            </div>
            <Skeleton className="h-6 w-full mt-6 mx-auto md:mx-0" data-sentry-element="Skeleton" data-sentry-source-file="footer-loader.tsx" />
          </div>

          <div className="w-full md:w-1/3 mb-8">
            <Skeleton className="h-8 w-1/2 mx-auto md:mx-0 mb-4" data-sentry-element="Skeleton" data-sentry-source-file="footer-loader.tsx" />
            <Skeleton className="h-4 w-full mb-2" data-sentry-element="Skeleton" data-sentry-source-file="footer-loader.tsx" />
            <Skeleton className="h-4 w-full mb-2" data-sentry-element="Skeleton" data-sentry-source-file="footer-loader.tsx" />
            <Skeleton className="h-4 w-full mb-2" data-sentry-element="Skeleton" data-sentry-source-file="footer-loader.tsx" />
          </div>

          <div className="w-full md:w-1/4">
            <Skeleton className="h-8 w-1/2 mx-auto md:mx-0 mb-2" data-sentry-element="Skeleton" data-sentry-source-file="footer-loader.tsx" />
            <ul className="space-y-2 mb-6">
              <Skeleton className="h-4 w-full" data-sentry-element="Skeleton" data-sentry-source-file="footer-loader.tsx" />
              <Skeleton className="h-4 w-full" data-sentry-element="Skeleton" data-sentry-source-file="footer-loader.tsx" />
              <Skeleton className="h-4 w-full" data-sentry-element="Skeleton" data-sentry-source-file="footer-loader.tsx" />
              <Skeleton className="h-4 w-full" data-sentry-element="Skeleton" data-sentry-source-file="footer-loader.tsx" />
            </ul>
            <Skeleton className="h-8 w-1/3 mx-auto md:mx-0" data-sentry-element="Skeleton" data-sentry-source-file="footer-loader.tsx" />
          </div>
        </div>
      </div>
      <div className="mt-8 pt-4 pb-4 border-t border-gray-300">
        <div className="container mx-auto px-4 flex flex-col md:flex-row justify-between items-center text-center md:text-left">
          <Skeleton className="h-4 w-1/3" data-sentry-element="Skeleton" data-sentry-source-file="footer-loader.tsx" />
          <div className="flex justify-center md:justify-start space-x-4">
            <Skeleton className="h-6 w-12" data-sentry-element="Skeleton" data-sentry-source-file="footer-loader.tsx" />
            <Skeleton className="h-6 w-12" data-sentry-element="Skeleton" data-sentry-source-file="footer-loader.tsx" />
            <Skeleton className="h-6 w-20" data-sentry-element="Skeleton" data-sentry-source-file="footer-loader.tsx" />
          </div>
        </div>
      </div>
    </footer>;
};
export default SkeletonFooter;